import { getHopinRoot } from '@hopin-team/config-hopin-constants';

export enum PAGE_TYPE {
  EVENT_RECEPTION = 'EVENT_RECEPTION',
  EVENT_REPLAY = 'EVENT_REPLAY',
}

const buildPageUrl = (pageType: PAGE_TYPE, eventSlug: string) => {
  switch (pageType) {
    case PAGE_TYPE.EVENT_RECEPTION:
      return `events/${eventSlug}/reception`;
    case PAGE_TYPE.EVENT_REPLAY:
      return `events/${eventSlug}/replay`;
  }
};

export function getUrl(page: PAGE_TYPE, slug: string) {
  return `${getHopinRoot()}/${buildPageUrl(page, slug)}`;
}

export function redirectTopWindow(href: string) {
  if (window.location !== window.parent.location && !!window.top) {
    window.top.location.href = href;
  } else {
    window.location.href = href;
  }
}

export function redirectTo(type: PAGE_TYPE, slug: string) {
  try {
    const newHref = getUrl(type, slug);
    redirectTopWindow(newHref);
  } catch (e) {
    // TODO: Understand what needs to be done here. The UI is already rendering. So, ideally we shouldn't do nothing
  }
}

export function getEventSlug(location: Pick<Location, 'pathname'>) {
  const [eventSlug] = location.pathname.split('/').slice(-1);
  return eventSlug;
}

export interface UtmCodeParams {
  utm_source: Nullable<string>;
  utm_campaign: Nullable<string>;
  utm_medium: Nullable<string>;
  utm_content: Nullable<string>;
  utm_term: Nullable<string>;
}
export function getUtmCodeParams(querystring: string): UtmCodeParams {
  const params = new URLSearchParams(querystring);

  return {
    utm_source: params.get('utm_source'),
    utm_campaign: params.get('utm_campaign'),
    utm_medium: params.get('utm_medium'),
    utm_content: params.get('utm_content'),
    utm_term: params.get('utm_term'),
  };
}

export function getUrlDetails() {
  const { pathname, search } = window.location;
  const [slug] = pathname.split('/').slice(-1);
  const params = new URLSearchParams(search);

  const seriesExternalId = params.get('series_external_id');
  const widgetId = params.get('widget_id');
  const widgetSource = widgetId
    ? 'widget'
    : params.get('widget_source') || 'unknown';
  const code = params.get('code');

  return {
    slug,
    widgetSource,
    widgetId,
    code,
    seriesExternalId,
  };
}
